<app-modal-header [hasClose]='true' [title]="'INCLUIR DESTINATÁRIO(S)'" (handleClose)="close()"></app-modal-header>

@if (loading) {
  <mat-progress-bar mode="query" style="margin: 10px 0px;"></mat-progress-bar>
}

@if (!loading) {
  <mat-dialog-content class="content-dialog">
    <div class="row">
      <div>
        <mat-radio-group [(ngModel)]="type" (change)="generateForm($event)">
          <mat-radio-button checked value="1">GRUPO DE USUÁRIOS</mat-radio-button>
          <mat-radio-button value="2">INDIVIDUAL</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
    <form [formGroup]="form" focusFirstInvalidField (ngSubmit)="form.valid && myControl.valid && addRecipient()">
      @if (type == '1') {
        <div class="row">
          <div>
            <mat-form-field class="half-input" >
              <mat-select matSelect formControlName="profile_id" placeholder="Perfil de Acesso *" (selectionChange)="verifyRequeriments($event)">
                @for (item of profiles; track item) {
                  <mat-option [value]="item">
                    {{item.description}}
                  </mat-option>
                }
              </mat-select>
              @if (form.get('profile_id').errors && form.get('profile_id').touched) {
                <mat-error>
                  {{form.get('profile_id').errors['message']}}
                </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
        @if (form.dirty) {
          <div>
            <div class="row">
              <div>
                <mat-form-field class="half-input">
                  <mat-select matSelect formControlName="regional_id" placeholder="Departamento Regional" (selectionChange)="filterSchool($event)">
                    <mat-option value="" selected>Todos</mat-option>
                    @for (dr of drs; track dr) {
                      <mat-option [value]="dr.id">
                        {{dr.description}}
                      </mat-option>
                    }
                  </mat-select>
                  @if (form.get('regional_id').errors && form.get('regional_id').touched) {
                    <mat-error>
                      {{form.get('regional_id').errors['message']}}
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div>
                <mat-form-field>
                  <mat-select matSelect formControlName="school_id" placeholder="Escolas" (selectionChange)="filterCourse($event)">
                    <mat-option value="" selected>Todos</mat-option>
                    @for (school of schools; track school) {
                      <mat-option [value]="school.id">
                        {{school.description}}
                      </mat-option>
                    }
                  </mat-select>
                  @if (form.get('school_id').errors && form.get('school_id').touched) {
                    <mat-error>
                      {{form.get('school_id').errors['message']}}
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div>
                <mat-form-field>
                  <mat-select matSelect formControlName="course_id" placeholder="Curso">
                    <mat-option value="" selected>Todos</mat-option>
                    @for (course of courses; track course) {
                      <mat-option [value]="course.id">
                        {{course.description}}
                      </mat-option>
                    }
                  </mat-select>
                  @if (form.get('course_id').errors && form.get('course_id').touched) {
                    <mat-error>
                    {{form.get('course_id').errors['message']}}</mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
          </div>
        }
      }
      @if (type == '2') {
        <mat-form-field class="example-full-width">
          <input type="text" placeholder="Usuários" matInput [formControl]="myControl" [matAutocomplete]="auto" required>
          <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
            @for (option of filteredOptions | async; track option) {
              <mat-option [value]="option">
                {{option.name}}
              </mat-option>
            }
          </mat-autocomplete>
          @if (myControl.errors && myControl.touched) {
            <mat-error>
              {{myControl.errors['message']}}
            </mat-error>
          }
        </mat-form-field>
      }
      <div class="modal-footer">
        <button mat-raised-button type="button" color="basic" style="margin-right: 15px;" (click)="resetForm()" [disabled]="!form.dirty">
          Redefinir
        </button>
        <button mat-raised-button color="accent" class="primary-action-btn">
          Adicionar
        </button>
      </div>
    </form>
  </mat-dialog-content>
}
